<template>
  <div style="padding: 18px; padding-top: 10px">
    <v-card>
      <v-card class="card" style="height: 50%">
        <div style="width: 100%">
          <v-row>
            <v-col cols="12" sm="3" md="3">
              <v-select
                v-model="search.merchant_type"
                :items="merchantType"
                label="Tipe Merchant"
                item-text="text"
                item-value="value"
                clearable
                hide-details="true"
                dense
              />
            </v-col>

            <v-col cols="12" sm="3" md="3">
              <v-select
                v-model="search.merchant_criteria"
                :items="listMerchantCriteria"
                label="Skala Usaha"
                item-text="text"
                item-value="value"
                clearable
                hide-details="true"
                dense
              />
            </v-col>

            <v-col cols="12" sm="3" md="3">
              <v-select
                v-model="search.qr_type"
                :items="listQrType"
                label="Jenis QR"
                item-text="text"
                item-value="value"
                clearable
                hide-details="true"
                dense
              />
            </v-col>

            <v-col cols="12" sm="3" md="3">
              <v-select
                v-model="search.settlement_type"
                :items="settlementTypeItems"
                label="Settlement Type"
                item-text="text"
                item-value="value"
                clearable
                hide-details="true"
                dense
              />
            </v-col>

            <v-col cols="12" sm="3" md="3">
              <v-select
                v-model="search.payment_type"
                :items="paymentType"
                label="Jenis Transaksi"
                item-text="text"
                item-value="value"
                clearable
                hide-details="true"
                dense
              />
            </v-col>

            <v-col cols="12" sm="3" md="3">
              <v-select
                v-model="search.status"
                :items="statusTrans"
                label="Status Transaksi"
                item-text="text"
                item-value="value"
                clearable
                hide-details="true"
                dense
              />
            </v-col>

            <v-col cols="12" sm="3" md="3">
              <v-select
                v-model="search.sof"
                :items="sofTrans"
                label="Source of Fund"
                item-text="text"
                item-value="value"
                clearable
                hide-details="true"
                dense
              />
            </v-col>

            <v-col cols="12" sm="3" md="3">
              <v-select
                label="Wilayah"
                v-model="search.kode_wilayah"
                :items="itemsWilayah"
                item-text="nama_wilayah"
                item-value="kode_wilayah"
                clearable
                hide-details="true"
                dense
              />
            </v-col>

            <v-col cols="12" sm="3" md="3">
              <v-select
                v-model="search.settlement_status"
                :items="settlementStatus"
                label="Settlement Status"
                item-text="text"
                item-value="value"
                clearable
                hide-details="true"
                dense
              />
            </v-col>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-col cols="12" sm="3" md="3" v-bind="attrs" v-on="on">
                  <v-dialog
                    ref="rangeDateDialog"
                    v-model="rangeDateDialog"
                    :return-value.sync="search.date"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        id="rangeDate"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-model="dateRangeText"
                        label="Select Date"
                        hide-details="true"
                        dense
                      />
                    </template>

                    <v-date-picker
                      v-model="search.created_at"
                      scrollable
                      range
                      :max="getTommorowDate(0)"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        color="primary"
                        @click="rangeDateDialog = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="
                          () => {
                            checkRangeDate();
                            $refs.rangeDateDialog.save(search.created_at);
                          }
                        "
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </template>
              <span
                v-text="dateRangeText == '' ? 'not selected' : dateRangeText"
              />
            </v-tooltip>

            <v-col cols="12">
              <v-btn class="ma-1" small color="warning" @click.stop="showData">
                <v-icon left> mdi-magnify </v-icon>
                search
              </v-btn>
              <v-btn class="ma-1" small @click="clearMerchant"> Reset </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>

      <div class="container" v-if="loadingCount">
        <div class="card-container">
          <v-card class="card-loader">
            <div class="card-content">
              <div class="grey-text mb-2">
                <v-skeleton-loader type="article" />
              </div>
            </div>
          </v-card>

          <v-card class="card-loader">
            <div class="card-content">
              <div class="grey-text mb-2">
                <v-skeleton-loader type="article" />
              </div>
            </div>
          </v-card>
        </div>
      </div>

      <div class="card-container" v-else>
        <v-card class="card">
          <div class="card-content">
            <div class="merchant">Jumlah Transaksi</div>

            <div class="totmerchant">{{ countTransaction }}</div>
          </div>
        </v-card>

        <v-card class="card">
          <div class="card-content">
            <div class="aggregator">Sales Volume</div>

            <div class="totagregator">{{ countSalesVolume }}</div>
          </div>
        </v-card>
      </div>

      <div class="card-container">
        <v-card class="card h-fit-content flex-column text-center">
          <div class="grafikmerchant">Grafik Transaksi Wilayah</div>

          <div>
            <v-row>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-col cols="12" sm="3" md="3" v-bind="attrs" v-on="on">
                    <v-dialog
                      ref="rangeDateDialogGrafik"
                      v-model="rangeDateDialogGrafik"
                      :return-value.sync="searchtrans.date_grafik"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          id="rangeDate"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          v-model="dateRangeTextGrafik"
                          label="Select Date"
                          hide-details="true"
                          dense
                        />
                      </template>

                      <v-date-picker
                        v-model="searchtrans.date_grafik"
                        scrollable
                        range
                        :max="getTommorowDate(0)"
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="rangeDateDialogGrafik = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="
                            () => {
                              checkRangeDateGrafik();
                              $refs.rangeDateDialogGrafik.save(
                                searchtrans.date_grafik
                              );
                            }
                          "
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </template>
                <span
                  v-text="
                    dateRangeTextGrafik == ''
                      ? 'not selected'
                      : dateRangeTextGrafik
                  "
                /> </v-tooltip
              ><br />

              <v-col cols="12" sm="1" md="1">
                <v-btn class="ma-1" small @click="clearGrafik"> Reset </v-btn>
              </v-col>
            </v-row>
          </div>
          <br />

          <div class="card-container" v-if="loadinglist">
            <v-card class="card-loader-grafik">
              <div class="card-content">
                <div class="grey-text mb-2">
                  <v-skeleton-loader type="article" />
                </div>
              </div>
            </v-card>
          </div>

          <chart-profiling
            v-else
            :chartData="dataTransaction"
            :options="chartOptionsSales"
            :chart-id="'transaction-chart'"
            :height="200"
          />
        </v-card>
      </div>
    </v-card>
  </div>
</template>

<script>
import {
  dataListMerchantCriteria,
  dataQrType,
  dataSettlementTypeItems,
  dataTipeMerchantOnboarding,
  dataListTrxReportStatus,
  sof,
  dataListSettlementStatus,
  dataProfilingPaymentType,
} from '../../store/params';

import { date, showAlert, getTommorowDate } from '../../lib/helpers';

export default {
  components: {
    ChartProfiling: () => import('../../components/ChartProfiling'),
  },
  data: () => ({
    rangeDateDialog: false,
    rangeDateDialogGrafik: false,
    geAreaWilayah: [],
    loadingCount: false,
    loadinglist: false,
    dataTransaction: {},
    chartOptionsSales: {},
    countTransaction: null,
    countSalesVolume: null,
    getGarfik: false,

    search: {
      merchant_type: '',
      merchant_criteria: '',
      qr_type: '',
      settlement_type: '',
      date: [],
      status: '',
      sof: '',
      kode_wilayah: '',
      settlement_status: '',
      payment_type: '',
    },

    searchtrans: {
      date_grafik: [],
    },

    merchantType: dataTipeMerchantOnboarding,
    listMerchantCriteria: dataListMerchantCriteria,
    listQrType: dataQrType,
    settlementTypeItems: dataSettlementTypeItems,
    paymentType: dataProfilingPaymentType,
    statusTrans: dataListTrxReportStatus,
    sofTrans: sof,
    wilayahList: sof,
    settlementStatus: dataListSettlementStatus,
  }),

  computed: {
    dateRangeText() {
      return this.search.date.join(' ~ ');
    },

    dateRangeTextGrafik() {
      return this.searchtrans.date_grafik.join(' ~ ');
    },

    dataGrafikSalesVolume() {
      return this.$store.state.dashboardProfiling.grafikTransaksi;
    },

    itemsWilayah() {
      return this.$store.state.dashboardProfiling.allActiveWilayah;
    },
  },

  created() {
    this.getCountTransaction();
    this.getCountSalesVolume();
  },

  async mounted() {
    this.getWilayah();
  },

  methods: {
    clearFilter() {
      this.search.merchant_type = '';
      this.search.merchant_criteria = '';
      this.search.qr_type = '';
      this.search.settlement_type = '';
      this.search.date = [];
      this.search.status = '';
      this.search.sof = '';
      this.search.kode_wilayah = '';
      this.search.settlement_status = '';
      this.search.payment_type = '';
    },

    clearGrafikFilter() {
      this.searchtrans.date_grafik = [];
    },

    clearMerchant() {
      this.clearFilter();
      this.getCountTransClear();
      this.getCountSalesVolume();
    },

    clearGrafik() {
      this.clearGrafikFilter();
      this.getGrafikTransWilayah();
    },

    checkRangeDate() {
      if (this.search.date.length == 1) {
        this.search.date.push(this.search.date[0]);
      }
    },

    checkRangeDateGrafik() {
      if (this.searchtrans.date_grafik) {
        const [grafik1, grafik2] = this.searchtrans.date_grafik;
        const d1 = Date.parse(grafik1);
        const d2 = Date.parse(grafik2);

        if (d1 > d2) {
          const temp = this.searchtrans.date_grafik[1];
          this.searchtrans.date_grafik[1] = grafik1;
          this.searchtrans.date_grafik[0] = temp;
        }
      }

      this.searchtrans = { ...this.searchtrans };
      const result = this.getValDate(this.searchtrans.date_grafik);
      if (result > 30) {
        showAlert(
          this.$store,
          'Range date must be <= 31 days',
          'mdi-alert',
          'red'
        );
        return false;
      }
      if (this.searchtrans.date_grafik.length == 1) {
        this.searchtrans.date_grafik.push(this.searchtrans.date_grafik[0]);
      }
      this.getGrafikTransWilayah();
      return true;
    },

    getWilayah() {
      this.$store.dispatch('dashboardProfiling/fetchActiveArea', {
        date,
      });
    },

    async getCountTransaction() {
      this.loadingCount = true;
      this.loadinglist = true;
      this.search.date.sort();
      await this.$store
        .dispatch('dashboardProfiling/getCountTransaksi', {
          date,
          search: this.search,
        })
        .then((transaction) => {
          this.countTransaction = transaction;
        })
        .finally(() => {
          this.getGrafikTransWilayah();
          this.loadingCount = false;
          this.loadinglist = false;
        });
    },

    async getCountSalesVolume() {
      this.loadingCount = true;
      this.search.date.sort();
      await this.$store
        .dispatch('dashboardProfiling/getSalesVolume', {
          date,
          search: this.search,
        })
        .then((salesVolume) => {
          this.countSalesVolume = salesVolume;
        })
        .finally(() => {
          this.loadingCount = false;
        });
    },

    async getCountTransClear() {
      this.loadingCount = true;
      this.search.date.sort();
      await this.$store
        .dispatch('dashboardProfiling/getCountTransaksi', {
          date,
          search: this.search,
        })
        .then((merchant) => {
          this.countTransaction = merchant;
        })
        .finally(() => {
          this.loadingCount = false;
        });
    },

    showData() {
      this.search = { ...this.search };
      const result = this.getValDate(this.search.date);
      if (result > 30) {
        showAlert(
          this.$store,
          'Range date must be <= 31 days',
          'mdi-alert',
          'red'
        );
        return false;
      }
      this.getDataList();
      return true;
    },

    getDataList() {
      this.getCountTransFilter();
      this.getCountSalesVolumeFilter();
    },

    getValDate(dateVal) {
      const date1 = new Date(dateVal[0]);
      const date2 = new Date(dateVal[1]);
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },

    async getCountTransFilter() {
      this.loadingCount = true;
      this.search.date.sort();
      await this.$store
        .dispatch('dashboardProfiling/getCountTransaksi', {
          date,
          search: this.search,
        })
        .then((transaction) => {
          this.countTransaction = transaction;
        })
        .finally(() => {
          this.loadingCount = false;
        });
    },

    async getCountSalesVolumeFilter() {
      this.loadingCount = true;
      this.search.date.sort();
      await this.$store
        .dispatch('dashboardProfiling/getSalesVolume', {
          date,
          search: this.search,
        })
        .then((salesVolume) => {
          this.countSalesVolume = salesVolume;
        })
        .finally(() => {
          this.loadingCount = false;
        });
    },

    async getGrafikTransWilayah() {
      this.loadinglist = true;
      await this.$store
        .dispatch('dashboardProfiling/getGrafikWilayah', {
          date,
          search: this.searchtrans,
        })
        .then(() => {
          const dataLebel = this.dataGrafikSalesVolume;
          const namaWilayah = [];
          const dataTotal = [];
          dataLebel.map((item) => {
            namaWilayah.push(item.nama_wilayah);
            dataTotal.push(item.total_transaksi);
          });

          this.dataTransaction = {
            labels: namaWilayah,
            datasets: [
              {
                label: 'Jumlah Transaksi Wilayah',
                backgroundColor: '#e36013',
                fill: false,
                borderColor: '#e36013',
                data: dataTotal,
              },
            ],
          };

          this.chartOptionsSales = {
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    callback: (value) =>
                      new Intl.NumberFormat('de-DE').format(value), // numeral(value).format('0.0,[00]'),
                  },
                },
              ],
            },

            tooltips: {
              callbacks: {
                label(tooltipItem, data) {
                  const { label } = data.datasets[tooltipItem.datasetIndex];
                  const value = new Intl.NumberFormat('de-DE').format(
                    tooltipItem.yLabel
                  );
                  return `${label}: ${value}`;
                },
              },
            },
          };

          this.getGarfik = true;
        })
        .finally(() => {
          this.loadinglist = false;
        });
    },
    getTommorowDate,
  },
};
</script>

<style scoped>
.v-tab {
  text-transform: none !important;
  font-family: sans-serif;
  font-weight: 400;
}

.card-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.card-loader {
  display: flex;
  flex: 1;
  height: 140px;
  margin: 15px;
  min-width: 250px;
  padding: 25px;
}

.card {
  display: flex;
  flex: 1;
  height: 140px;
  margin: 15px;
  min-width: 250px;
  padding: 25px;
}

.h-fit-content {
  height: fit-content;
}

.card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.aggregator {
  text-align: center;
  font-size: 18px;
  color: orangered;
  font-weight: 500;
}

.totagregator {
  text-align: center;
  font-size: 25px;
  font-weight: 500;
  color: #146b84;
}

.merchant {
  text-align: center;
  font-size: 18px;
  color: orangered;
  font-weight: 500;
}

.totmerchant {
  text-align: center;
  font-size: 25px;
  font-weight: 500;
  color: #146b84;
}

.grafikmerchant {
  text-align: left;
  font-size: 18px;
  color: orangered;
  font-weight: 400;
}

.card-loader-grafik {
  display: flex;
  flex: 1;
  height: 300px;
  margin: 15px;
  min-width: 250px;
  padding: 25px;
}

.tablist {
  color: orangered;
  font-weight: 540;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px;
}
</style>
